import React, { type ReactNode } from "react";
import { View, type ViewStyle, type StyleProp } from "react-native";
import { useSafeAreaInsets, type EdgeInsets } from "react-native-safe-area-context";
import { StyleSheet, useUnistyles } from "react-native-unistyles";

type ScreenContainerProps = {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
  edges?: Array<keyof EdgeInsets>;
  backgroundColor?: string;
};

export function ScreenContainer({ children, style, edges = ["top", "bottom", "left", "right"] }: ScreenContainerProps) {
  const insets = useSafeAreaInsets();
  const { theme } = useUnistyles();

  const safeAreaStyle = {
    paddingTop: edges.includes("top") ? insets.top : 0,
    paddingBottom: edges.includes("bottom") ? insets.bottom : 0,
    paddingLeft: edges.includes("left") ? insets.left : 0,
    paddingRight: edges.includes("right") ? insets.right : 0,
    backgroundColor: theme.colors.background,
  };

  return <View style={[styles.container, safeAreaStyle, style]}>{children}</View>;
}

const styles = StyleSheet.create((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
  },
}));
